import { useLocalStorage } from 'usehooks-ts';

export const WEBSITE_UPDATES_BANNER_KEY = 'ncWebsiteUpdatesBannerOpen';

export type UseWebsiteUpdatesBannerT = () => readonly [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
];

export const useWebsiteUpdatesBanner: UseWebsiteUpdatesBannerT = () => {
  const [isOpen, setIsOpen] = useLocalStorage<boolean>(
    WEBSITE_UPDATES_BANNER_KEY,
    true,
  );

  return [isOpen, setIsOpen] as const;
};
